import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const HomeIndexLazy = React.lazy(
	() => import(/* webpackChunkName : 'HomeIndex' */ './components/HomeIndex')
);

export default (store) => {
	return {
		index: true,
		element: <AsyncLoading component={<HomeIndexLazy />} />,
	};
};
